import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableRow,
} from '../Table/Table';
import { PackageInfoTableProps } from './types';

export const PackageInfoTable = ({
  packageName,
  packageFormat,
  latestVersion,
  fileSize,
  latestRelease,
  microcopy,
  className,
}: PackageInfoTableProps) => {
  return (
    <Table className={className}>
      <TableCaption>{microcopy.title}</TableCaption>
      <TableBody variant="alternate">
        <TableRow>
          <TableCell>{microcopy.packageName}</TableCell>
          <TableCell>{packageName}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{microcopy.packageFormat}</TableCell>
          <TableCell>{packageFormat}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{microcopy.latestVersion}</TableCell>
          <TableCell>{latestVersion}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{microcopy.fileSize}</TableCell>
          <TableCell>{fileSize}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{microcopy.latestRelease}</TableCell>
          <TableCell>{latestRelease}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
